import { Injectable } from '@angular/core';
import {
    HttpEvent, HttpInterceptor, HttpHandler,
    HttpRequest, HttpResponse
} from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import { finalize, tap, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
    constructor() {

    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (req.url.includes('/v2')) {
            const re = this.encryptUsingAES256(req.body);

            // const clonedRequest = req.clone({ body:null, setHeaders: { resource: re } }); // if plaintext is sent instead of json
            const clonedRequest = req.clone({ body: { encStr: re } }); // if json is sent instead of plaintext

            return next.handle(clonedRequest).pipe(map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    if (event.url.includes('/v2')) {
                        const re = this.decryptUsingAES256(event.body.data);
                        // const re = this.decryptUsingAES256(event.body);
                        return event.clone({ body: JSON.parse(re) });
                    }
                }

                return event;
            })).pipe(tap((httpEvent: HttpEvent<any>) => this.logResponse(httpEvent)));
        }

        return next.handle(req).pipe(tap((httpEvent: HttpEvent<any>) => this.logResponse(httpEvent)));
    }

    private logResponse(httpEvent: HttpEvent<any>): void {
        if (httpEvent instanceof HttpResponse) {
            // console.log(httpEvent);
        }
    }

    encryptUsingAES256(payload) {
        let _key = CryptoJS.enc.Base64.parse(environment.encDensKey);
        let _iv = CryptoJS.enc.Base64.parse(environment.encDensKey);
        let encrypted = CryptoJS.AES.encrypt(JSON.stringify(payload), _key,
            {
                keySize: 32,
                // iv: _iv,
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            });
        return encrypted.toString();
    }

    decryptUsingAES256(encrypted) {
        let _key = CryptoJS.enc.Base64.parse(environment.encDensKey);
        let _iv = CryptoJS.enc.Base64.parse(environment.encDensKey);

        return CryptoJS.AES.decrypt(encrypted, _key,
            {
                keySize: 32,
                // iv: _iv,
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }).toString(CryptoJS.enc.Utf8);
    }
}
